import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { Layout, AlertContext } from '../widgets'
import * as routes from '../routes'
import {
  AdminPostCell,
} from './components'
import {
  Loading,
  withRouter,
} from '../shared'
import { Cell, NavigationTab, PaginatedList } from '../components'

const tabs = [
  'Posts',
]

const AdminEditHashtag = (props) => {
  const [currentTab, setTab] = useState(tabs[0])
  const [loading, setLoading] = useState(true)

  const [hashtag, setHashtag] = useState(null)

  const hashtagId = () => props.router.params.hashtagId

  useEffect(() => {
    load()
  }, [hashtagId()])

  const { showAlert, showAlertConfirm, handleError } = useContext(AlertContext)

  const load = () => {
    setLoading(true)
    axios.get(
      routes.dynamic(routes.adminHashtagUrl, hashtagId())
    ).then((response) => {
      const hashtag = response.data
      setHashtag(hashtag)
    }).catch(handleError).finally(() => {
      setLoading(false)
    })
  }

  if (loading) {
    return <Loading />
  }

  return (
    <div className='body-container'>
      <Layout>
        <Layout.Header>
          #{hashtag.id}
        </Layout.Header>

        <Cell>
          <Cell.Image src={hashtag.images && hashtag.images['400']} alt='' large />
        </Cell>

        <div className='navigation-tabs'>
          {tabs.map((tab, i) =>
            <NavigationTab
              key={i}
              text={tab}
              isActive={currentTab === tab}
              onClick={() => {
                if (currentTab !== tab) {
                  setTab(tab)
                }
              }}
            />
          )}
        </div>

        {currentTab === 'Posts' &&
          <PaginatedList key={'posts'}
            loadUrl={routes.dynamic(routes.getPostsHashtagFeedUrl, hashtagId())}
            cell={AdminPostCell}
            cellItemPropName={'post'}
          />
        }

      </Layout>
    </div>
  )
}

export default withRouter(AdminEditHashtag)
